export interface SubtitleItem {
    // Linear index, first subtitle item has index 0
    index: number;
    // Start in milliseconds relative to the segment's start
    start: number;
    // End in milliseconds relative to the segment's start
    end: number;
    // Optional name of the speaker
    speaker?: string;
    // Text
    text: string;
}

export interface MediaItemSegment {
    /* Linear index, first segments has index 0 */
    index: number;
    /* Title of the segment */
    title: string;
    /* Text or description of the segment */
    text: string;
    /* Duration in milliseconds */
    duration: number;
    /* Offset in milliseconds from the beginning of the media item */
    offset: number;
    /* URL of the segment on the web */
    url: string;
    /* Media URL pointing to a video or audio file */
    mediaUrl?: string;
    /* Optional subtitles */
    subtitles?: SubtitleItem[];
}

export interface MediaItem {
    /* unique across all items */
    id: string;
    /* Encodes tv::channel::broadcast, radio::channel::broadcast, podcast::podcast-name, news::paper-name::resort, etc. */
    path: string;
    /* Publication date as returned by Date.toISOString() */
    date: string;
    /* Title of the item, broadcast episode title, podcast episode title, news article title */
    title: string;
    /* Text of the item, e.g. broadcast episode description, podcast episode description, news article full text or summary */
    text: string;
    /* Duration in milliseconds for audio and video media, 0 for text media */
    duration: number;
    /* Thumbnail URL */
    thumbUrl?: string;
    /* URL of the media item on the web */
    url: string;
    /* Media URL, pointing to a video or audio file */
    mediaUrl?: string;
    /* Optional segments of audio and video media */
    segments?: MediaItemSegment[];
}

export type SourceType = "tv" | "radio" | "podcast" | "newspaper";
export const itemPathSeparator = "-";
export function itemPath(segments: string[]) {
    return [...segments].join(itemPathSeparator);
}

export function getSourcePath(path: string): string {
    const parts = path.split(itemPathSeparator);
    return parts.slice(0, 2).join(itemPathSeparator);
}

export type SourceSpec =
    | {
          type: "orf";
      }
    | {
          type: "orf-radio";
          excludedTitles: string[];
      }
    | { type: "podcast"; shortName: string; displayName: string; rssUrl: string; cutoffDate: string };
